<template lang="pug">
.json-pretty
  pre.json-object(v-if="jsonPretty" v-html="jsonPretty")
  textarea(style="height: 0; width:0; opacity: 0;" ref="textarea" v-model="jsonString")
  button.clipboard-button.btn.btn-default(v-if="!noClipboard" @click="copyToClipboard()") Copy To clipboard
</template>

<script>

function syntaxHighlight(data) {
  let json = data
  if (typeof json !== 'string') {
    json = JSON.stringify(json, undefined, 2)
  }
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, (match) => {
    let cls = 'number'
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'key'
      } else {
        cls = 'string'
      }
    } else if (/true|false/.test(match)) {
      cls = 'boolean'
    } else if (/null/.test(match)) {
      cls = 'null'
    }
    return `<span class="${cls}">${match}</span>`
  })
}

export default {
  props: ['jsonObject', 'noClipboard'],
  methods: {
    copyToClipboard() {
      const copyText = this.$refs.textarea
      copyText.select()
      document.execCommand('copy')
    }
  },
  computed: {
    jsonPretty() {
      return syntaxHighlight(this.jsonString)
    },
    jsonString() {
      return JSON.stringify(this.jsonObject, null, 2)
    }
  }
}
</script>

<style lang="scss">
.json-pretty {
  position: relative;
  .clipboard-button {
    z-index: 500;
    position: absolute;
    right: 0;
    top: 0;
    margin: 10px 15px 0 0;
  }

  pre {
    min-height: 100px;
    padding: 5px;
    margin: 5px;
  }

  .string {
    color: #0F83A1;
  }

  .number {
    color: #FF5100;
  }

  .boolean {
    color: #364156;
  }

  .null {
    color: #FF47DA;
  }

  .key {
    color: #004FE1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PrettyJson.vue